import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AccountCodeService from '../../../../services/AccountCodeService';

const ViewAccountCode = () => {
    const { id } = useParams();
    const [accountcode, setAccountcode] = useState({
        projectRequired: '',
        accountName: '',
        accountNumber: '',
        project: '',
        accountDescription: '',
        accountCategory: ''
    });

    const fetchAccountcode = async () => {
        try {
            const response = await AccountCodeService.view(id);
            setAccountcode(response.data);
        } catch (error) {
            console.error('Failed to fetch account code:', error);
        }
    };

    useEffect(() => {
        fetchAccountcode();
    }, [id]);

    return (
        <div>
            <h1>View Account Code</h1>
            <p><strong>ID:</strong> {id}</p>
            <p><strong>Project Required:</strong> {accountcode.projectRequired}</p>
            <p><strong>Account Name:</strong> {accountcode.accountName}</p>
            <p><strong>Account Number:</strong> {accountcode.accountNumber}</p>
            <p><strong>Project:</strong> {accountcode.project}</p>
            <p><strong>Account Description:</strong> {accountcode.accountDescription}</p>
            <p><strong>Account Category:</strong> {accountcode.accountCategory}</p>
        </div>
    );
};

export default ViewAccountCode;
